var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.common-qifu-pop[data-v-1b19a769] {\n  background: transparent;\n  overflow: visible;\n}\n.pop-content[data-v-1b19a769] {\n  width: 8.787rem;\n  height: 9.773rem;\n  position: relative;\n  background: url(" + escape(require("../../image/commonQifuPop/bg.png")) + ") no-repeat center / 100% 100%;\n}\n.open-btn[data-v-1b19a769] {\n  position: absolute;\n  left: 50%;\n  bottom: 0.680rem;\n  width: 7.013rem;\n  height: 1.707rem;\n  -webkit-transform: translateX(-50%);\n      -ms-transform: translateX(-50%);\n          transform: translateX(-50%);\n  border: 0;\n  outline: none;\n  padding: 0;\n  background: url(" + escape(require("../../image/commonQifuPop/btn.png")) + ") no-repeat center / 100% 100%;\n  font-family: inherit;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoaders=1?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1b19a769","scoped":true,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!(webpack)-px-to-rem?{"basePx":75,"min":1}!./src/common/components/commonQifuPop.vue
// module id = 303
// module chunks = 32